import get from 'lodash/get';

export const prepJSONforSecuritiesGrid = (values, priceData) => {
  let newData = [];
  if (values && values.length > 0) {
    newData = values.map((value) => {
      const ticker = get(value, 'security.ticker', '');
      const currentPrice = get(priceData, `['${ticker}'].pricedata.last`, null);
      const costBasis = get(value, 'shortTermCostBasis', '0.00') === '0.00' ?
        get(value, 'longTermCostBasis', '0.00') : get(value, 'shortTermCostBasis', '0.00');
      const purchasePrice = Number.isFinite(Number.parseFloat(get(value, 'shareQuantity', null))) ?
        costBasis / Number.parseFloat(get(value, 'shareQuantity')) : null;
      const currentChange = purchasePrice && currentPrice ?
        ((currentPrice - purchasePrice) / purchasePrice) * 100 : null;
      // FDIC Cash cannot be bought or sold through my ipo
      //  and there is no detail data to display
      const disableLink = ticker === 'FDIC.CASH';
      return ([
        {
          name: value.security.companyName,
          linkTo: `/securities/${ticker}`,
          disabled: disableLink,
        },
        get(value, 'shareQuantity', ''),
        purchasePrice,
        currentPrice,
        Number.parseFloat(costBasis),
        currentPrice * get(value, 'shareQuantity', 0),
        currentChange,
      ]);
    });
  }

  return newData;
};

export const prepJSONforPrivGrid = (values, priceData, additionalDetail = false) => {
  let newData = [];
  if (values && values.length > 0) {
    newData = values.map((value) => {
      const purchasePrice = get(priceData, `['${value.security.ticker}'].pricedata.myipopurchaseprice`, null);
      const currentPrice = get(priceData, `['${value.security.ticker}'].pricedata.last`, null);
      // Include total purchase price to be summed for account value change
      const details = additionalDetail ? [
        purchasePrice * get(value, 'shareQuantity', 0),
      ] : [];
      return ([
        {
          name: value.security.companyName,
          linkTo: `/priv-securities/${value.security.ticker}`,
        },
        get(value, 'shareQuantity', ''),
        purchasePrice,
        currentPrice,
        currentPrice * get(value, 'shareQuantity', 0),
        ...details,
      ]);
    });
  }

  return newData;
};



// WEBPACK FOOTER //
// ./src/components/Portfolio/prepJsonForGrids.js